
export const StopTypeEnum = {
  Start: 1,
  Finish: 2,
  Order: 3,
  Location: 4,
  Break: 5,
  LoadIndicator: 6,
} as const

export const ReverseStopTypeLookup = {
  1: 'Start',
  2: 'Finish',
  3: 'Order',
  4: 'Location',
  5: 'Break',
  6: 'LoadIndicator',
}

export type StopType = typeof StopTypeEnum[keyof typeof StopTypeEnum]
